// extracted by mini-css-extract-plugin
module.exports = {"root":"Headings-module--root--2qczK","mainHeading":"Headings-module--mainHeading--UhkWs","subHeading":"Headings-module--subHeading--1JaXt"};